import Box from "../../Box";
import MasonryGrid from "../../MasonryGrid";

interface Props {
	cards: React.ReactElement[];
}
const ReportCardsContainer = ({ cards }: Props) => {
	const [first, second, ...rest] = cards;

	return (
		<>
			<MasonryGrid fullWidth>{first}</MasonryGrid>
			<Box marginTop={-16} paddingVertical={16}>
				{second}
			</Box>
			<MasonryGrid>{rest}</MasonryGrid>
		</>
	);
};

export default ReportCardsContainer;
